module.exports = __webpack_public_path__ + "static/img/video-9.51abf29.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/video-9.jpg
// module id = QX16
// module chunks = 12